// ═══════════════════════════════════════════════════════════════════════════
// @dxf-ai-editor/command-engine — CECOLOR / COLOR / ЦВЕТ ($CECOLOR) mutation
// ═══════════════════════════════════════════════════════════════════════════
//
// AutoCAD's COLOR command (aliases COL / -COLOR / SETCOLOR; RU ЦВЕТ) sets the
// CURRENT colour — the DXF HEADER `$CECOLOR` system variable (group 62) — that
// NEWLY-created entities inherit. It does NOT recolour any existing geometry; it
// only changes the document-level current-colour state.
//
// Per CLAUDE.md "любые изменения геометрии/модели только через Command Engine":
// the document-level `cecolor` field is mutated exclusively through this helper.
// The inverse (undo) is produced by `computeInverse` in geometryMutations.ts,
// which snapshots the prior colour from the pre-mutation document — so undo
// restores the previous current colour as a single atomic step. This mirrors the
// BASE / `$INSBASE` `applySetInsertionBase` precedent exactly.
// ═══════════════════════════════════════════════════════════════════════════

import type {
  DrawingDocument,
  EntityColor,
} from "@dxf-ai-editor/drawing-model";

/**
 * Return a new {@link DrawingDocument} whose `cecolor` field is set to the given
 * {@link EntityColor} ($CECOLOR). Pure / immutable — the input document is not
 * mutated. The result is a shallow spread; callers that need a fully re-validated
 * document (the geometry reducer) wrap this in `assembleDrawingDocument`.
 */
export function applySetCeColor(
  document: DrawingDocument,
  color: EntityColor,
): DrawingDocument {
  return { ...document, cecolor: color };
}
